// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';

import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { IconProps } from './interfaces';
import InternalIcon from './internal';

export { IconProps };

export default function Icon({ size = 'normal', variant = 'normal', ...props }: IconProps) {
  const baseComponentProps = useBaseComponent('Icon', { props: { name: props.name, size, variant } });
  return <InternalIcon size={size} variant={variant} {...props} {...baseComponentProps} />;
}

applyDisplayName(Icon, 'Icon');



// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/src/icon/index.tsx